module.exports = __webpack_public_path__ + "static/img/bg-tr.4755dafd.webp";